import { LngLatBounds } from 'maplibre-gl';
import type { RawCoordinates, Transform } from '../map-types';
import { isPointInBounds } from './is-point-in-bounds';

export const isPointInPaddedBounds = (
  point?: RawCoordinates,
  transform?: Transform | null,
  padding: number = 100
) => {
  if (!point || !transform) {
    return false;
  }

  const bounds = transform.getBounds();
  const sw = transform.project(bounds.getSouthWest());
  const ne = transform.project(bounds.getNorthEast());

  sw.x -= padding;
  sw.y += padding;
  ne.x += padding;
  ne.y -= padding;

  const newSw = transform.unproject(sw);
  const newNe = transform.unproject(ne);

  const paddedBounds = new LngLatBounds(newSw, newNe);

  return isPointInBounds(point, paddedBounds);
};
